import React from 'react';
import Category from '../Category/Category';
import Navbar from '../Navbar/Navbar';

const Home = () => {
    return (
        <div>
            <Navbar></Navbar>
            <Category></Category>
        </div>
    );
};

export default Home;